import React, { Box, Tab } from '@mui/material';
import { useState, SyntheticEvent } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { WeekReporting, MonthReporting, CustomersReporting } from 'components';

export const Reporting = () => {
	const [value, setValue] = useState('1');

	const handleChange = (event: SyntheticEvent, newValue: string) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: '100%', typography: 'body1' }}>
			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
					<TabList onChange={handleChange} aria-label='lab API tabs example'>
						<Tab label='Week' value='1' />
						<Tab label='Month' value='2' />
						<Tab label='Customers' value='3' />
					</TabList>
				</Box>
				<TabPanel value='1'>
					<WeekReporting />
				</TabPanel>
				<TabPanel value='2'>
					<MonthReporting />
				</TabPanel>
				<TabPanel value='3'>
					<CustomersReporting />
				</TabPanel>
			</TabContext>
		</Box>
	);
}
